var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-row',{staticClass:"image-text-content",style:({
    'background-color': _vm.content.background,
    color: _vm.content.text_color
  }),attrs:{"justify":"center","align":"center"}},_vm._l((_vm.content.cardcontent_set || []),function(sub_content){return _c('vs-col',{key:sub_content.id,staticClass:"text--html image-box",attrs:{"lg":"6","sm":"6","xs":"12","justify":"left"}},[_c('CardContent',{staticClass:"image",attrs:{"content":sub_content}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }